import React from 'react';
import WrappedBase from './WrappedBase';

import Sidebar from '../containers/Sidebar';

export default class SidebarWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <Sidebar {...this.props} />
      </WrappedBase>
    );
  }
}
